export default {
  en: {
    shipments: {
      offer: {
        range: 'Your offer can be at least {min} and maximum {max} euro.',
        placebuttoncaption: 'Place an offer',
        placecta: 'Make an offer',
        made: 'Offer made',
        cancel: 'Delete offer',
        accepted: 'Offer accepted'
      },
      active_shipment: 'Active shipment',
      view_attachment: 'View',
      tags: {
        refrigerated: 'Refrigerated {min}°C / {max}°C',
        frozen: 'Frozen {min}°C / {max}°C',
        refrigeratedshort: 'Refrigerated',
        frozenshort: 'Frozen',
        dangerous_goods: 'Dangerous goods (ADR)',
        loading_bridge_required: 'Loading bridge required',
        loading_bridge: 'Loading bridge',
        no_stacking: 'No stacking',
        breakable: 'Breakable',
        fragile: 'Breakable',
        food_donation: 'Food donation',
        tags: 'Extra'
      },
      sort: {
        most_recent: 'Most recent',
        oldest: 'Oldest',
        newest_state: 'Newest state',
        oldest_state: 'Oldest state'
      },
      errors: {
        size_mismatch: "One or more packages won't fit in this vehicle.",
        weight_mismatch: "One or more packages are too heavy for this vehicle.",
        no_valid_business_driver: "This user's profile is not complete.",
        license_needed: 'This driver needs an approved transport license (>500 kg loading capacity).'      
      },
      filters: {
        shipments: 'Offers',
        pickup: 'Pick up',
        delivery: 'Delivery',
        dimensions: 'Properties',
        type: 'Shipment types',
        clear: 'Undo filter',
        nooffers: 'Show shipments without offer',
        offersonly: 'Show shipments with offer',
        showpickuplabel: 'Pick-up location in radius of',
        showdeliverylabel: 'Delivery location in radius of',
        locationplaceholder: 'location',
        pickupdatelabel: 'Pick-up time between',
        deliverydatelabel: 'Delivery time between',
        radius: 'radius',
        dimensionsandweight: 'Dimensions and weight',
        notfounddisclaimer: 'Try adjusting your search',
        notfound: 'No shipments found',
        notavailable: 'No shipments available',
        notavailabledisclaimer:
          'There are currently no shipments available. Try again later.',
        mynotavailabledisclaimer:
          'You have no shipments yet, go to search to place an offer.',
        status: 'Status'
      },
      packages: {
        description: 'description',
        types: {
          small: 'Small',
          medium: 'Medium',
          large: 'Large',
          box: 'Boxed',
          unboxed: 'Bulk',
          pallet_euro: 'Europallet',
          pallet_iso: 'ISO-pallet',
          pallet: 'Pallet'
        }
      },
      showonmap: 'Show on map',
      pickupmarkers: 'Pick-up locations',
      deliverymarkers: 'Delivery locations',
      suggestedroutes: 'Suggested routes',
      backto: 'Back to {to}',
      assigndriver: 'You have to assign a driver to this shipment!',
      assigndriverbtn: 'Assign driver',
      pickup_from: 'Pick-up from',
      pickup_on: 'Pick-up on',
      delivery_from: 'Delivery from',
      delivery_on: 'Delivery on',
      till: 'Untill',
      changestate: 'Change status',
      invoicereference: 'Invoice reference',
      transportcost: 'Transport cost',
      times: {
        arrangement: 'By appointment',
        evening: 'in the evening',
        morning: 'morning',
        workday: 'workday',
        afternoon: 'afternoon',
        between: 'between'
      },
      pickuptimezonedisclaimer: 'Timezone of pickup location: {tz}',
      deliverytimezonedisclaimer: 'Timezone of delivery location: {tz}',
      search: 'search',
      pods: 'Proof of delivery'
    }
  },
  nl: {
    shipments: {
      offer: {
        range: 'Je bod mag minimaal {min} en maximaal {max} euro bedragen.',
        placebuttoncaption: 'Plaats bod',
        placecta: 'Doe een bod',
        made: 'Bod geplaatst',
        cancel: 'Annuleer bod',
        accepted: 'Bod aanvaard'
      },
      errors: {
        size_mismatch: 'Een of meer pakketjes passen niet in dit voertuig.',
        no_valid_business_driver: 'Het profiel van deze chauffeur is niet compleet.',
        license_needed: 'Er is een goedgekeurde transportvergunning nodig voor deze chauffeur (>500 kg laadvermogen).',      
        weight_mismatch: "Een of meer pakketjes zijn te zwaar voor dit voertuig.",        
      },
      active_shipment: 'Actieve zending',
      view_attachment: 'Bekijk',
      tags: {
        refrigerated: 'Koeltransport {min}°C / {max}°C',
        frozen: 'Vriestransport {min}°C / {max}°C',
        refrigeratedshort: 'Koeltransport',
        frozenshort: 'Vriestransport',
        dangerous_goods: 'Gevarengoed (ADR)',
        loading_bridge_required: 'Laadklep noodzakelijk',
        loading_bridge: 'Laadklep',
        no_stacking: 'Niet stapelen',
        breakable: 'Breekbaar',
        fragile: 'Breekbaar',
        food_donation: 'Voedselschenking',
        tags: 'Extra'
      },
      sort: {
        most_recent: 'Nieuwste eerst',
        oldest: 'Oudste eerst',
        newest_state: 'Nieuwste status',
        oldest_state: 'Oudste status'
      },
      filters: {
        shipments: 'Boden',
        pickup: 'Ophalen',
        delivery: 'Leveren',
        dimensions: 'Eigenschappen',
        type: 'Type zendingen',
        clear: 'Wis filter',
        nooffers: 'Toon zendingen zonder bod',
        offersonly: 'Toon zendingen met bod',
        showpickuplabel: 'Ophalen in straal van',
        showdeliverylabel: 'Leveren in straal van',
        locationplaceholder: 'Locatie',
        pickupdatelabel: 'Ophaalmoment tussen',
        deliverydatelabel: 'Levermoment tussen',
        radius: 'Straal',
        dimensionsandweight: 'Afmetingen en gewicht',
        notfounddisclaimer: 'Probeer je zoekopdracht aan te passen',
        notfound: 'Geen zendingen gevonden',
        notavailable: 'Geen zendingen beschikbaar',
        notavailabledisclaimer:
          'Momenteel zijn er geen zendingen beschikbaar. Probeer het later opnieuw.',
        mynotavailabledisclaimer:
          'Je hebt nog geen zendingen, ga naar zoeken om een bod uit te brengen.',
        status: 'Status'
      },
      packages: {
        description: 'Beschrijving',
        types: {
          small: 'Klein',
          medium: 'Gemiddeld',
          large: 'Groot',
          box: 'Verpakt',
          unboxed: 'Bulk',
          pallet_euro: 'Europallet',
          pallet_iso: 'ISO-pallet',
          pallet: 'Pallet'
        }
      },
      showonmap: 'Toon op kaart',
      pickupmarkers: 'Ophaallocaties',
      deliverymarkers: 'Leverlocaties',
      suggestedroutes: 'Voorgestelde routes',
      backto: 'Terug naar {to}',
      assigndriver: 'Er moet nog een chauffeur worden toegewezen aan deze zending!',
      assigndriverbtn: 'Wijs een chauffeur toe',
      pickup_from: 'Ophalen vanaf',
      pickup_on: 'Ophalen op',
      delivery_from: 'Leveren vanaf',
      delivery_on: 'Leveren op',
      till: 'Tot en met',
      changestate: 'Wijzig status',
      invoicereference: 'Factuurreferentie',
      transportcost: 'Kost transport',
      times: {
        arrangement: 'Op afspraak',
        evening: "'s Avonds",
        morning: 'Voormiddag',
        workday: 'Werkdag',
        afternoon: 'Namiddag',
        between: 'Tussen'
      },
      pickuptimezonedisclaimer: 'Tijdzone van ophaallocatie: {tz}',
      deliverytimezonedisclaimer: 'Tijdzone van leverlocatie: {tz}',
      search: 'Zoeken',
      pods: 'Leverbewijs'
    }
  },
   fr: {
    shipments: {
      offer: {
        range: 'Votre offre peut être au moins {min} et maximale {max} euros.',
        placebuttoncaption: 'Faites une offre',
        placecta: 'Faites une offre',
        made: 'Offre faite',
        cancel: 'Annuler l\'offre',
        accepted: 'Offre acceptée'
      },
      errors: {
         size_mismatch: 'Un ou plusieurs packages ne rentrent pas dans ce véhicule.',
         no_valid_business_driver: 'Le profil de ce pilote n\'est pas complet.',
         license_needed: 'Un permis de transport approuvé est requis pour ce conducteur (charge utile> 500 kg).',
         weight_mismatch: "Un ou plusieurs colis sont trop lourds pour ce véhicule.",      
      },
      active_shipment: 'Envoi active',
      view_attachment: 'Voir',
      tags: {
        refrigerated: 'Transport frigorifique {min}°C / {max}°C',
        frozen: 'Transport gelé {min}°C / {max}°C',
        refrigeratedshort: 'Transport frigorifique',
        frozenshort: 'Transport gelé',
        dangerous_goods: 'Marchandises dangereuses (ADR)',
        loading_bridge_required: 'hayon nécessaire',
        loading_bridge: 'Hayon',
        no_stacking: 'Ne pas empiler',
        breakable: 'Fragile',
        fragile: 'Fragile',
        food_donation: 'Don de nourriture',
        tags: 'Extra'
      },
      sort: {
        most_recent: 'Plus récent d\'abord',
        oldest: 'Plus vieux d\'abord',
        newest_state: 'Dernier statut',
        oldest_state: 'Plus vieux statut'
      },
      filters: {
        shipments: 'Offres',
        pickup: 'Ramasser',
        delivery: 'Livrer',
        dimensions: 'Caractéristiques',
        type: 'Type d\'envois',
        clear: 'Supprimer filtre',
        nooffers: 'Montrez envois sans offre',
        offersonly: 'Montrez envois avec offre',
        showpickuplabel: 'Ramasser dans un rayon de',
        showdeliverylabel: 'Livrer dans un rayon de',
        locationplaceholder: 'Lieu',
        pickupdatelabel: 'Temps de prise en charge entre',
        deliverydatelabel: 'Temps de livraison entre',
        radius: 'Rayon',
        dimensionsandweight: 'Dimensions et poids',
        notfounddisclaimer: 'Essayez d\'ajuster votre recherche',
        notfound: 'Aucun envoi trouvé',
        notavailable: 'Aucun envoi disponible',
        notavailabledisclaimer:
          'Aucun envoi disponible pour le moment. Essayez de nouveau plus tard.',
        mynotavailabledisclaimer:
          'Vous n\'avez aucun envoi pour le moment, aller à recherche pour faire une offre.',
        status: 'Statut'
      },
      packages: {
        description: 'Déscription',
        types: {
          small: 'petit',
          medium: 'moyen',
          large: 'Grand',
          box: 'emballé',
          unboxed: 'vrac',
          pallet_euro: 'Europalette',
          pallet_iso: 'ISO-palette',
          pallet: 'Palette'
        }
      },
      showonmap: 'Montrer sur la carte',
      pickupmarkers: 'Lieux de collecte',
      deliverymarkers: 'Lieux de livraison',
      suggestedroutes: 'Itinéraires suggérés',
      backto: 'Retour à {to}',
      assigndriver: 'Un chauffeur doet être affecté à cette envoi',
      assigndriverbtn: 'Assigne un chauffeur',
      pickup_from: 'Collecter à partir de',
      pickup_on: 'Collecter à',
      delivery_from: 'Livrer à partir de',
      delivery_on: 'Livrer à',
      till: 'a',
      changestate: 'Change statut',
      invoicereference: 'Réference de facture',
      transportcost: 'Frais de transport',
      times: {
        arrangement: 'Sur rendez-vous',
        evening: 'Le soir',
        morning: 'Le matin',
        workday: 'Jour ouvrable',
        afternoon: 'Après-midi',
        between: 'entre'
      },
      pickuptimezonedisclaimer: 'Fuseau horaire du lieu de collecte: {tz}',
      deliverytimezonedisclaimer: 'Fuseau horaire du lieu de livraison: {tz}',
      search: 'Chercher',
      pods: 'Preuve de livraison'
    }
  },
}

